export const BREAKPOINTS = {
  mobile: 0,
  tablet: 640,
  large_tablet: 768,
  desktop: 1025,
  ultrawide: 1280,
};

export const STORAGE_COURSE_KEY = `${process.env.GATSBY_SITE_ID}_FV_COURSES`;
export const STORAGE_HOTEL_KEY = `${process.env.GATSBY_SITE_ID}_FV_HOTELS`;

export const USER_MENU = [
  {
    id: "my-account",
    url: "/account",
    name: "My Account",
  },
  {
    id: "active-bookings",
    url: "/account/bookings",
    name: "Active Bookings",
  },
  {
    id: "my-favourites",
    url: "/account/favourites",
    name: "My Favourites",
  },
  {
    id: "recently-viewed",
    url: "/account/recentlyviewed",
    name: "Recently Viewed",
  },
];
